import AppContext from "AppContext";
import { useContext } from "react";
import { Navigate, useNavigate } from "react-router-dom";

const Index = (props) => {
  const { state, actions } = useContext(AppContext)

  if (state.user) {
    return <Navigate to="/admin/dashboard" replace />
  }

  return (
    <>
    </>
  );
};

export default Index;
